import React from 'react';
import { Link } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { MyRoute } from 'routes';
import { Divider } from '@mui/material';

const MDAvatar =  require('components/MDAvatar').default;
const SidenavItem = require('../SidenavItem').default;
const SidenavList = require('../SidenavList').default;
const SidenavCollapse = require('../SidenavCollapse').default;
const MDTypography = require('components/MDTypography').default;


export const renderNestedCollapse = (
  collapse: MyRoute[],
  color: string,
  pathname: string
) => {
  return collapse.map(({ name, route, key, href }) => {
    if (href) {
      return (
        <Link
          key={key}
          href={href}
          target="_blank"
          rel="noreferrer"
          sx={{ textDecoration: "none" }}
        >
          <SidenavItem 
            color={color}
            name={name || ""} 
            active={false}
            nested={true}
            children={null}
            open={false}
            notifications={undefined}
          />
        </Link>
      );
    }
    return (
      <NavLink to={route || ""} key={key} style={{ textDecoration: "none" }}>
        <SidenavItem 
          color={color}
          name={name || ""} 
          active={route === pathname} 
          nested={true}
          children={null}
          open={false}
          notifications={undefined}
        />
      </NavLink>
    );
  });
};

export const renderCollapse = (
  collapses: MyRoute[],
  color: string,
  pathname: string,
  openNestedCollapse: string[],
  setOpenNestedCollapse: (value: string[]) => void,
  currentRole: any,
  notifications: { [key: string]: number }
) => {
  return collapses.map(({ name, collapse, route, href, key, hide, accessNumber, notificationKey }) => {
    let returnValue;
    if (collapse) {
      if (!hide && currentRole?.hasAccessPage(accessNumber)) {
        returnValue = (
          <SidenavItem
            key={key}
            color={color}
            name={name || ""}
            active={key === pathname.split("/")[2] ? "isParent" : false}
            open={openNestedCollapse.includes(key || "")}
            onClick={(event) => {
              // Only toggle collapse if clicking directly on the parent item
              if (event.currentTarget.classList.contains("MuiListItem-root")) {
                const newOpenState = openNestedCollapse.includes(key || "")
                  ? openNestedCollapse.filter(k => k !== key)
                  : [...openNestedCollapse, key || ""];
                setOpenNestedCollapse(newOpenState);
              }
            }}
            notifications={notifications && notificationKey ? notifications[notificationKey] : undefined}
            nested={false}
            children={renderNestedCollapse(collapse, color, pathname)}
          />
        );
      }
    } else {
      if (!hide && currentRole?.hasAccessPage(accessNumber)) {
        returnValue = href ? (
          <Link
            href={href}
            key={key}
            target="_blank"
            rel="noreferrer"
            sx={{ textDecoration: "none" }}
          >
            <SidenavItem 
              color={color} 
              name={name || ""} 
              active={key === pathname.split("/").pop()} 
              notifications={notifications && notificationKey ? notifications[notificationKey] : undefined}
              nested={false}
              children={null}
              open={false}
            />
          </Link>
        ) : (
          <NavLink to={route || ""} key={key} style={{ textDecoration: "none" }}>
            <SidenavItem 
              color={color} 
              name={name || ""} 
              active={key === pathname.split("/").pop()} 
              notifications={notifications && notificationKey ? notifications[notificationKey] : undefined}
              nested={false}
              children={null}
              open={false}
            />
          </NavLink>
        );
      }
    }
    if (returnValue) {
      return <SidenavList key={key}>{returnValue}</SidenavList>;
    }
    return null;
  });
};

export const renderRoutes = (
  routes: MyRoute[],
  color: string,
  pathname: string,
  openCollapse: string | false,
  setOpenCollapse: (value: string | false) => void,
  openNestedCollapse: string[],
  setOpenNestedCollapse: (value: string[]) => void,
  currentRole: any,
  notifications: { [key: string]: number },
  currentUser: any,
  textColor: string
) => {
  return routes.map(
    ({ type, name, icon, title, collapse, noCollapse, key, href, hide, accessNumber, notificationKey }) => {
      let returnValue;
      const notificationsCount = collapse?.filter(c => c.notificationKey).reduce((acc, c) => {
        return acc + (notifications && c.notificationKey ? Number(notifications[c.notificationKey] || 0) : 0);
      }, 0);

      if (type === "collapse" && currentRole?.hasAccessPage(accessNumber)) {
        if (name === "User") {
          icon = <MDAvatar src={currentUser?.avatar || ""} alt="User" size="sm" />;
        }
        returnValue = href ? (
          <Link
            href={href}
            key={key}
            target="_blank"
            rel="noreferrer"
            sx={{ textDecoration: "none" }}
          >
            <SidenavCollapse
              name={name || ""}
              icon={icon}
              active={key === pathname.split("/")[1]}
              noCollapse={noCollapse}
            />
          </Link>
        ) : (
          <SidenavCollapse
            key={key}
            name={
              name === "User"
                ? currentUser?.firstName + " " + currentUser?.lastName?.[0] + "."
                : name || ""
            }
            icon={icon}
            active={key === pathname.split("/")[1]}
            open={openCollapse === key}
            onClick={() => (openCollapse === key ? setOpenCollapse(false) : setOpenCollapse(key || ""))}
            notifications={notificationsCount}
          >
            {collapse ? renderCollapse(collapse, color, pathname, openNestedCollapse, setOpenNestedCollapse, currentRole, notifications) : null}
          </SidenavCollapse>
        );
      } else if (type === "title") {
        returnValue = (
          <MDTypography
            key={key}
            color={textColor}
            display="block"
            variant="caption"
            fontWeight="bold"
            textTransform="uppercase"
            pl={3}
            mt={2}
            mb={1}
            ml={1}
          >
            {title}
          </MDTypography>
        );
      } else if (type === "divider") {
        returnValue = (
          <Divider
            key={"divider-22"}
            sx={{ mx: 2, my: 1 }}
            style={{
              color: "white",
              borderStyle: "dotted",
              borderWidth: "2px",
            }}
          />
        );
      }
      return returnValue;
    }
  );
}; 